export const BILLING_DIALOG_PAPER_SX = {
  width: 'min(96vw, 1600px)',
  height: '90vh',
  maxWidth: '96vw',
  maxHeight: '90vh',
};
